var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Thanks4Reg"},[_c('h1',[_vm._v("Vielen Dank für die Registrierung, "+_vm._s(_vm.fetchUsername))])])}
var staticRenderFns = []

export { render, staticRenderFns }